import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import dataQualityEnhancementPageData from '../data/servicePages/dataQualityEnhancement';

const DataQualityEnhancementPage = () => <ServicePageLayout data={dataQualityEnhancementPageData} />;

export default DataQualityEnhancementPage;
